import { render } from "./ModalDadosLoja.vue?vue&type=template&id=de99d138&scoped=true&ts=true"
import script from "./ModalDadosLoja.vue?vue&type=script&lang=ts"
export * from "./ModalDadosLoja.vue?vue&type=script&lang=ts"

import "./ModalDadosLoja.vue?vue&type=style&index=0&id=de99d138&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de99d138"]])

export default __exports__